export enum ResearchModule {
	FromScratch = 'FromScratch',
	BrandHealth = 'BrandHealth',
	BrandInnovation = 'BrandInnovation',
	WebsiteTesting = 'WebsiteTesting',
	PrototypeTesting = 'PrototypeTesting',
	ApplicationTesting = 'ApplicationTesting',
	ABTesting = 'ABTesting',
}
